import {getCurrentYear} from '../../utils/commons'
import WiseCompareLogo from './logo'
import {wiseCompareStylesUK} from './styles'

const baseConfig = {
  domainName: 'wisecompare' as const,
  domainType: 'picks' as const,
  siteName: 'Wise Compare',
  favicon: '/favicons/wisecompare.png',
}

const localeConfigs = {
  uk: {
    measurementId: 'G-YM4HHL8WDB',
    camelCaseUrl: 'WiseCompare.co.uk',
    logo: <WiseCompareLogo className="size-14 shrink-0 tablet:size-12" />,
    title: (category: string, count: string) =>
      `Top ${count} ${category} ${getCurrentYear()} in the UK | WiseCompare.co.uk – Smart Deals & Trusted Picks`,
    description: (_category?: string, _count?: string) =>
      `At WiseCompare.co.uk, we uncover the best products and deals across the UK. Explore expert reviews, top-rated picks, and money-saving insights to get the most value for every pound you spend.`,
    styles: wiseCompareStylesUK,
  },
}

export const createConfig = (locale: string = 'uk') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.uk
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
